var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBrothersLogoMobile = function SvgBrothersLogoMobile(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "brothers-logo-mobile_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 256 256",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".brothers-logo-mobile_svg__brothers-logo-mobile-path{fill:#fff!important}"))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h256v256H0z",
    style: {
      fill: "#000!important"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.94 36.05v183.9c0 .75.5 1.25 1.25 1.25h42.06v-34.31a1 1 0 0 1-.32-.73v-42.24c0-.32.14-.54.32-.73v-30.6c-.18-.19-.32-.41-.32-.73v-42c0-.32.14-.54.32-.73V34.82H77.19c-.75 0-1.25.49-1.25 1.24M156.96 126.26c16.15-3.72 20.63-16.65 20.63-29.08V72.33c0-25.35-18.64-37.53-39.27-37.53H123.6v33.8h6.02c4.72 0 7.7 2.48 7.7 8.94v26.59c0 6.21-2.98 8.95-7.7 8.95h-6.02v29.58h8.51c4.72 0 7.7 2.48 7.7 8.7v27.34c0 6.46-2.98 8.7-7.7 8.7h-8.51v33.79h17.2c20.63 0 39.26-12.18 39.26-37.52v-28.09c0-13.42-7.45-24.6-23.11-29.33",
    className: "brothers-logo-mobile_svg__brothers-logo-mobile-path"
  })));
};
export default SvgBrothersLogoMobile;